<template>
  <div v-if="vacancy">
    <div class="mb-3">
      <IntegrationsInviteMethod :vacancy="vacancy" />
    </div>
  </div>
</template>

<script>
import { candidateNotificationTypes, settingsEntityType } from '@/enums';
import IntegrationsInviteMethod from '@/components/Integrations/IntegrationsInviteMethod';

export default {
  name: 'IntegrationsVacancyInviteMethod',
  components: { IntegrationsInviteMethod },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      settingsEntityType,
      types: {
        [candidateNotificationTypes.EMAIL]: 'Email',
        [candidateNotificationTypes.SMS]: 'Email + SMS',
        [candidateNotificationTypes.CALL]: 'Email + SMS + Звонок роботом',
      },
    };
  },
};
</script>

<style scoped>

</style>
